var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import LogOut04Svg from './log-out-04.icon.svg';
export const LogOut04Icon = (iconInstanceProps) => (_jsx(Icon, { ...iconInstanceProps, SvgComponent: LogOut04Svg }));
_react_refresh_temp_1 = LogOut04Icon;
$RefreshReg$(_react_refresh_temp_1, "LogOut04Icon");
